import React from "react";

interface Option {
  value: string;
  label: string;
}

interface RadioGroupProps {
  label: string;
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  id?: string;
}

const RadioGroup: React.FC<RadioGroupProps> = ({
  label,
  options,
  value,
  onChange,
  error,
  required = false,
  id,
}) => {
  return (
    <div>
      {label && (
        <label htmlFor={id} className="block text-[#1E1E1E] text-[14px] mb-1">
          {label}
          {required && <span className="text-[#DC2626]">*</span>}
        </label>
      )}

      <div className="p-1">
        {options.map((option) => (
          <label
            key={option.value}
            className="flex items-center p-2 rounded hover:bg-[#F9FEFF] cursor-pointer"
          >
            <div className="relative flex items-center">
              <input
                type="radio"
                name={id}
                value={option.value}
                className="w-4 h-4 opacity-0 absolute"
                checked={value === option.value}
                onChange={() => onChange(option.value)}
              />
              <div
                className={`w-4 h-4 rounded-full border ${
                  value === option.value
                    ? "border-[#73B5C5]"
                    : "border-gray-300"
                } flex items-center justify-center mr-2`}
              >
                {value === option.value && (
                  <div className="w-2 h-2 rounded-full bg-[#73B5C5]"></div>
                )}
              </div>
            </div>
            <span
              className={`text-[#1E1E1E] text-[14px] ${
                value === option.value ? "text-[#73B5C5]" : ""
              }`}
            >
              {option.label}
            </span>
          </label>
        ))}
      </div>

      {error && (
        <p className="mt-0 text-[12px] font-[500] text-[#FF3B30]">{error}</p>
      )}
    </div>
  );
};

export default RadioGroup;
